import { ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup } from '@angular/forms';
import { LetDirective } from '@ngrx/component';
import { BehaviorSubject } from 'rxjs';
import { enterLeaveFastWithPadding } from 'src/app/animations/common.animations';
import { ActionAlertConditionOperatorPipe } from 'src/app/pipes/action-alert-condition-operator.pipe';
import { ActionAlertValue, SheetActionAlertService } from 'src/app/services/sheet-action-alert.service';
import { ActionAlert } from 'src/app/types/aggregate-graph.types';

interface FilteredAlertsViewModel {
	value: number | null,
	alerts: ActionAlert[]
}

@Component({
    selector: 'app-action-alert',
    templateUrl: './action-alert.component.html',
    styleUrl: './action-alert.component.scss',
    imports: [LetDirective, ActionAlertConditionOperatorPipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [enterLeaveFastWithPadding]
})
export class ActionAlertComponent implements OnInit {

	@Input() controlName!: string;
	@Input() alerts!: ActionAlert[];
	@Input() form!: FormGroup;

	private triggeredAlertBehaviorSubject = new BehaviorSubject<FilteredAlertsViewModel>({ value: null, alerts: [] });
	triggeredAlerts$ = this.triggeredAlertBehaviorSubject.asObservable();

	constructor(private destroyRef: DestroyRef, private sheetActionAlertService: SheetActionAlertService) {
	}

	ngOnInit(): void {
		(this.form && this.form.controls[this.controlName] as FormControl<ActionAlertValue>)?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(actionAlertValue => {
			var value = this.getValueFromActionAlertValue(actionAlertValue);
			this.triggeredAlertBehaviorSubject.next({
				value: this.getValueFromActionAlertValue(actionAlertValue),
				alerts: this.sheetActionAlertService.getTriggeredAlertsForControl(value, this.controlName, this.alerts)
			});
		});

		const value = this.getValueFromActionAlertValue(this.form.value[this.controlName] as ActionAlertValue);
		this.triggeredAlertBehaviorSubject.next({
			value: value,
			alerts: this.sheetActionAlertService.getTriggeredAlertsForControl(value, this.controlName, this.alerts)
		});
	}

	private getValueFromActionAlertValue(actionAlertValue: ActionAlertValue): number | null {
		if (actionAlertValue === null) return null;
		if (typeof actionAlertValue === 'number') return actionAlertValue;
		return actionAlertValue.quantity;
	}
}